// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conn-form-radio-group__hint .yfm p {
  max-width: 500px;
  line-height: 16px;
  color: var(--g-color-text-secondary);
}
.conn-form-radio-group__text-container {
  display: flex;
}
.conn-form-radio-group__text {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
.conn-form-radio-group__icon_end {
  margin-left: 4px;
  display: inline-flex;
}
.conn-form-radio-group__icon_view_error {
  color: var(--g-color-text-danger-heavy);
}
.conn-form-radio-group__icon_view_warn {
  color: var(--g-color-text-warning);
}`, "",{"version":3,"sources":["webpack://./src/ui/units/connections/components/ConnectorForm/components/RadioGroup/RadioGroup.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;EACA,iBAAA;EACA,oCAAA;AAAR;AAGI;EACI,aAAA;AADR;AAII;EACI,oBAAA;EACA,mBAAA;EACA,mBAAA;AAFR;AAMQ;EACI,gBAAA;EACA,oBAAA;AAJZ;AAOQ;EACI,uCAAA;AALZ;AAQQ;EACI,kCAAA;AANZ","sourcesContent":[".conn-form-radio-group__hint .yfm p {\n  max-width: 500px;\n  line-height: 16px;\n  color: var(--g-color-text-secondary);\n}\n.conn-form-radio-group__text-container {\n  display: flex;\n}\n.conn-form-radio-group__text {\n  display: inline-flex;\n  align-items: center;\n  white-space: nowrap;\n}\n.conn-form-radio-group__icon_end {\n  margin-left: 4px;\n  display: inline-flex;\n}\n.conn-form-radio-group__icon_view_error {\n  color: var(--g-color-text-danger-heavy);\n}\n.conn-form-radio-group__icon_view_warn {\n  color: var(--g-color-text-warning);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
